import React, { useContext } from 'react';
import { IntegrationSettingsInput } from '../../../../../../../types/integration_settings';
import { ActionModalBody, ActionModalFooter } from '../../../../../../components/Modal/templates/ActionModal';
import { Divider } from '../../../../../../components/Divider';
import { CancelButton, DeleteButton } from '../../../../../../components/Button';
import { translate } from '../../../../../../../types/translation/Translator';
import { TranslationKey } from '../../../../../../../types/translation/TranslationKey';
import { UserContext } from '../../../../../../../context/UserContext';
import { TextInput } from '../../../../../../components/TextInput';

interface MicrosoftIntegrationInfoPaneProps {
  input: IntegrationSettingsInput;
  loading: boolean;
  handleCancel: () => void;
  handleDelete: () => void;
}

export default function MicrosoftIntegrationInfoPane({
  input,
  loading,
  handleCancel,
  handleDelete,
}: MicrosoftIntegrationInfoPaneProps) {
  const { companyUsers } = useContext(UserContext);

  return (
    <>
      <ActionModalBody>
        <div className='flex flex-col gap-2'>
          <TextInput
            disabled={true}
            label={translate({ key: TranslationKey.type })}
            onChange={() => {}}
            value={'Microsoft'}
          />
          <TextInput
            disabled={true}
            label={translate({ key: TranslationKey.tenantId })}
            onChange={() => {}}
            value={input.tenantId}
          />
          <TextInput
            disabled={true}
            label={translate({ key: TranslationKey.administrator })}
            onChange={() => {}}
            value={companyUsers.get(input.userId || '')?.email}
          />
        </div>
      </ActionModalBody>
      <Divider />
      <ActionModalFooter>
        <div className='flex justify-between gap-2'>
          <DeleteButton loading={loading} onClick={handleDelete} />
          <CancelButton disabled={loading} onClick={handleCancel} />
        </div>
      </ActionModalFooter>
    </>
  );
}
